module.exports = __webpack_public_path__ + "img/pound-circle.12a05244.svg";